import React, { FC } from 'react';
import { parse, Context } from 'mustache';

interface MustacheNestedProps {
  template: ReturnType<typeof parse>;
  context: InstanceType<typeof Context>;
}

// renders nested mustache templates; e.g. use case: we can allocate
// segments of translation text to be wrapped in components defined in
// a mustache context, like for an inline <a />
const MustacheNestedRender: FC<MustacheNestedProps> = ({
  template,
  context,
}) => (
  <>
    {template.map(([type, value, start, end, nestedTemplate]) => {
      if (type === 'text') return value;
      if (type === 'name') {
        const templateLookup: unknown = context.lookup(value);
        return templateLookup;
      }
      if (type === '#') {
        const key = `${start}${end}`;

        const Component = context.lookup(value);

        if (!nestedTemplate) {
          return <Component key={key} />;
        }

        if (typeof nestedTemplate === 'string') {
          return <Component key={key}>{nestedTemplate}</Component>;
        }

        return (
          <Component key={key}>
            <MustacheNestedRender template={nestedTemplate} context={context} />
          </Component>
        );
      }
      return null;
    })}
  </>
);

export default MustacheNestedRender;
